



































































import { Component, Vue } from 'vue-property-decorator';
import { State, Getter, Mutation, Action } from 'vuex-class';
import { IAttributeFilterState, IFilter } from '@/store/types/IRootState';
import ImageComponent from '@/components/ImageComponent.vue';
import { formatString } from '@/services/StringFormatter';
import { isNameFilter } from '@/store/isNameFilter';

@Component({
    components: {
        ImageComponent,
    },
    methods: {
        formatString,
    },
})
export default class SearchFilter extends Vue {
    public numberFiltersToShow: number = 5;
    public showOtherAttributes = false;

    // getters
    @Getter
    public getAttributeFilters!: IAttributeFilterState[];
    @Getter
    public getNAttributeFilters!: IFilter[];
    @Getter
    public getShowFilterGroupAttributeFiltersFlag!: boolean;
    @Getter
    private displayAttributeFilter!: (attributeFilter: IAttributeFilterState) => boolean;

    // mutations
    @Mutation
    private addCustomAttributeFilter: any;
    @Mutation
    private toggleShowFilterGroupAttributeFlag: any;
    @Mutation
    private setSearchString: any;


    @Action
    public checkAttributeFilter: any;

    @State
    private searchString!: string;

    @State
    public attributeFilters!: IFilter[];

    public changeFilterCheckbox({ name, value }: IFilter): void {
        this.checkAttributeFilter({ filter: { name, value } });
    }

    public insertNewFilter(index: number, target: any): any {
        this.addCustomAttributeFilter({
            subFilterIndex: index,
            customFilter: target.value,
        });
    }

    public testIsName(atrib: string): boolean {
        return isNameFilter(atrib);
    }

    public toggleShowOtherAttributes() {
        this.showOtherAttributes = !this.showOtherAttributes;
    }
}
